// AUTO GENERATED FILE - Changes WILL be lost.
// th - used as 'th' fallback
export const common_fallback = true

export const translations = {}
